import { Button, Dialog } from '@economic/taco';
import { Trans } from '@lingui/macro';
import React from 'react';
import MoneyflowOnboardDialogFooter from '../../../sales/invoicing/invoices/book-and-send/moneyflow/always-on-version/MoneyflowOnboardDialogFooter';

interface Props {
    onDone: () => void;
}

export default function AcceptTermsAndConditions({ onDone }: Props) {
    return (
        <>
            <Dialog.Title>
                <Trans>Setup Instant payment</Trans>
            </Dialog.Title>
            <div className="pt-12 px-20">
                <p>
                    <Trans>Straksindbetaling is a financial service provided by our partner Moneyflow.</Trans>
                </p>
                <p>
                    <Trans>
                        In the next step, you will be presented with a contract between Moneyflow and your company's owner that
                        needs to be signed with MitID. You will also need to enter your company e-mail and phone number.
                    </Trans>
                </p>
                <p>
                    <Trans>
                        In order to provide this financial service, the following data will be shared with Moneyflow:
                        <strong>All data in your agreement (but NOT your login details)</strong>
                    </Trans>
                </p>
                <p>
                    <Trans>
                        The signee of the contract also agrees that your customer's CVR information will be shared with Moneyflow
                        when Straksindbetaling is initiated in order to present an offer.
                    </Trans>
                </p>
                <p>
                    <Trans>
                        By using this service, the Moneyflow e-mail address will be added as a cc recipient on e-mails sent to
                        your customers when the sale of an invoice is completed.
                    </Trans>
                </p>
            </div>
            <div className="flex flex-col items-center">
                <Button appearance="primary" onClick={onDone}>
                    <Trans>Accept and continue</Trans>
                </Button>
                <h4>
                    <Trans>It's free to sign up</Trans>
                </h4>
            </div>
            <MoneyflowOnboardDialogFooter />
        </>
    );
}
